import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Separator } from '../components/ui/separator';
import { FileText, CheckCircle2, CalendarDays, ArrowLeft } from 'lucide-react';

const ThanksPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-slate-100">
        <div className="max-w-6xl mx-auto px-6 py-4 flex justify-between items-center">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-8 h-8 bg-teal-600 rounded-lg flex items-center justify-center">
              <FileText className="w-5 h-5 text-white" />
            </div>
            <div className="flex items-baseline gap-2">
              <span className="font-bold text-slate-800 text-lg">記事監修マッチ</span>
              <span className="text-xs text-slate-500">by ミライトマッチ</span>
            </div>
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="py-20 px-6">
        <div className="max-w-2xl mx-auto">
          {/* Success Message */}
          <div className="text-center mb-12">
            <div className="w-20 h-20 bg-teal-50 rounded-full flex items-center justify-center mx-auto mb-6">
              <CheckCircle2 className="w-10 h-10 text-teal-600" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4">
              ご相談ありがとうございます。
            </h1>
            <p className="text-lg text-slate-600">
              お問い合わせ内容は、正常に送信されました。
              <br />
              担当スタッフが内容を確認のうえ、<span className="font-medium text-slate-700">1営業日以内</span>にご連絡いたします。
            </p>
          </div>

          {/* Info Card */}
          <Card className="border-slate-200 shadow-sm mb-8">
            <CardContent className="p-8">
              <p className="text-slate-600 leading-relaxed mb-6">
                この時点では、
              </p>
              <ul className="space-y-2 mb-6 text-slate-700">
                <li className="flex items-start gap-2">
                  <span className="text-slate-400">・</span>
                  <span>どの監修者が適切か</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-slate-400">・</span>
                  <span>どこまでを監修に含めるのがよいか</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-slate-400">・</span>
                  <span>費用感がどの程度になるか</span>
                </li>
              </ul>
              <p className="text-slate-600 leading-relaxed mb-8">
                といった点は、まだ確定していません。
                <br />
                <br />
                まずは状況を伺いながら、
                <br />
                確認すべき点や進め方を一緒に整理させてください。
              </p>

              <Separator className="my-8" />

              {/* Calendar Scheduling */}
              <div className="bg-slate-50 rounded-xl p-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center flex-shrink-0">
                    <CalendarDays className="w-6 h-6 text-teal-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-slate-800 mb-2">
                      日程調整（任意）
                    </h3>
                    <p className="text-slate-600 text-sm mb-4">
                      事前に日程を決めておきたい場合は、以下のURLからオンライン打ち合わせの日程をご予約いただくことも可能です。
                    </p>
                    <a
                      href="https://calendar.app.google/a3W2DCd8gLmGWD8m6"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 text-teal-600 hover:text-teal-700 font-medium transition-colors"
                    >
                      日程を予約する
                      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                      </svg>
                    </a>
                    <p className="text-slate-500 text-xs mt-4">
                      ※予約は必須ではありません
                      <br />
                      ※後ほどこちらから日程のご相談を差し上げる場合もあります
                    </p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Notes */}
          <div className="space-y-2 text-sm text-slate-500 mb-10">
            <p>・相談のみでも費用はかかりません</p>
            <p>・その場での発注判断は不要です</p>
            <p>・検討段階のご相談でも問題ありません</p>
          </div>

          {/* Back Link */}
          <div className="text-center">
            <Link to="/">
              <Button variant="ghost" className="text-slate-600 hover:text-slate-800">
                <ArrowLeft className="w-4 h-4 mr-2" />
                トップページに戻る
              </Button>
            </Link>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-8 px-6 bg-slate-100">
        <div className="max-w-6xl mx-auto text-center">
          <p className="text-slate-500 text-sm">
            ※営業目的のみのご連絡は行っておりません。
          </p>
        </div>
      </footer>
    </div>
  );
};

export default ThanksPage;
